import { Helper } from "../util/helper.js";
import React from "react";
export default class GridLayout extends React.Component<GridLayoutProps, GridLayoutState> {
    render() {
        const wrappedItems = React.Children.map(this.props.children, (child, idx) => {
            const config: GridLayoutConfig = Array.isArray(this.props.config) ? this.props.config[idx] : null;
            return (<GridLayoutItem layoutConfig={config}>{child}</GridLayoutItem>);
        })
        return <SimpleGridLayout>{wrappedItems}</SimpleGridLayout>

    }
}

export class SimpleGridLayout extends React.Component<React.PropsWithChildren, {}> {
    render() {
        return (
            <div className="grid-layout-wrapper">
                <div className="grid-layout-container">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export interface GridLayoutProps extends React.PropsWithChildren {
    //metaData?: Metadata;
    config?: GridLayoutConfig[];
}

interface GridLayoutState {

}

export type GridLayoutConfig = GridLayoutBreakPointConfig[];

export interface GridLayoutBreakPointConfig {
    breakPoint: BreakPoint;
    size: ItemSize;
    rowSize?: number;

}

export enum BreakPoint {
    ExtraSmall, Small, Medium, Large, ExtraLarge
}

export type ItemSize = "1/12" | "2/12" | "3/12" | "4/12" | "5/12" | "6/12" | "7/12" | "8/12" | "9/12" | "10/12" | "11/12" | "12/12";

export class GridLayoutItem extends React.Component<GridLayoutItemProps, GridLayoutItemState> {
    private _getSizeClasses = (config: GridLayoutConfig) => {
        if (config) {
            let classes: string[] = [];
            let rowClasses: string[] = [];

            config.forEach(cfg => {
                let sizeModifier = "";
                switch (cfg.breakPoint) {
                    case BreakPoint.Small:
                        sizeModifier = "s";
                        break;
                    case BreakPoint.Medium:
                        sizeModifier = "m";
                        break;
                    case BreakPoint.Large:
                        sizeModifier = "l";
                        break;
                    case BreakPoint.ExtraLarge:
                        sizeModifier = "xl";
                        break;
                    default:
                        sizeModifier = "xs";
                        break;
                }

                let tmpSize: ItemSize = Helper.hasValue(cfg.size) ? cfg.size : "12/12";
                let size = tmpSize.substr(0, cfg.size.trim().indexOf("/"));
                classes.push(`glc-${sizeModifier}-${size}`);

                if (Helper.hasValue(cfg.rowSize)) {
                    rowClasses.push(`glr-${sizeModifier}-${cfg.rowSize}`);
                }
            });

            return classes.join(" ") + " " + rowClasses.join(" ");
        } else {
            return "";
        }
    }

    render() {
        const classes = this._getSizeClasses(this.props.layoutConfig);
        const style: React.CSSProperties = {};
        if (this.props.gridColumnStart) {
            style.gridColumnStart = this.props.gridColumnStart;
        }
        if (this.props.renderCollapsed) {
            style.height = "0px";
            style.overflow = "hidden";
        }
        return (
            <div className={"grid-layout-container__item " + classes} style={style}>{this.props.children}</div>
        );
    }
}

interface GridLayoutItemProps extends React.PropsWithChildren {
    layoutConfig?: GridLayoutConfig;
    gridColumnStart?: number;
    renderCollapsed?: boolean;
}

interface GridLayoutItemState {

}
